@if (isDataImportVisible()) {
  <div class="mb-2 rounded border border-gray-300 bg-white p-4 shadow-md">
    <h2 class="p-4 text-xl">
      {{ 'ADMIN_PAGE.USERS.TABLE.DRAG_AND_DROP.TITLE' | translate }}
    </h2>
    <dnv-drag-drop-file-upload
      [isDataImportVisible]="isDataImportVisible"
      [isDataImportCompleted]="isDataImportCompleted"
      [isDataImportValid]="isDataImportValid"
      (importClicked)="import.emit($event)"
    />
  </div>
}
<h2 class="p-4 text-xl">
  {{ 'ADMIN_PAGE.USERS.TABLE.TITLE' | translate }}
</h2>
<div class="relative">
  <div class="flex h-20 items-center justify-end px-4">
    @if (isFilterVisible()) {
      <mat-form-field appearance="fill">
        <mat-label>
          {{ 'ADMIN_PAGE.USERS.BUTTONS.FILTER' | translate }}
        </mat-label>
        <input matInput (keyup)="applyFilter($event)" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    }
    <button
      mat-icon-button
      (click)="toggleDragAndDropVisibility()"
      [attr.aria-label]="
        'ADMIN_PAGE.USERS.TABLE.HEADER.ACTIONS.IMPORT_ARIA_LABEL' | translate
      "
      [matTooltip]="'ADMIN_PAGE.USERS.TABLE.HEADER.ACTIONS.IMPORT' | translate"
    >
      <mat-icon>swap_vert</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="deleteAllUsers.emit()"
      [attr.aria-label]="
        'ADMIN_PAGE.USERS.TABLE.HEADER.ACTIONS.DELETE_ALL_ARIA_LABEL'
          | translate
      "
      [matTooltip]="
        'ADMIN_PAGE.USERS.TABLE.HEADER.ACTIONS.DELETE_ALL' | translate
      "
    >
      <mat-icon>playlist_remove</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="toggleFilterVisibility()"
      [attr.aria-label]="
        'ADMIN_PAGE.USERS.TABLE.HEADER.ACTIONS.FILTER_ARIA_LABEL' | translate
      "
      [matTooltip]="'ADMIN_PAGE.USERS.TABLE.HEADER.ACTIONS.FILTER' | translate"
    >
      <mat-icon>filter_list</mat-icon>
    </button>
    <button
      mat-icon-button
      color="primary"
      (click)="openAddDialog()"
      [attr.aria-label]="
        'ADMIN_PAGE.USERS.TABLE.HEADER.ACTIONS.ADD_ARIA_LABEL' | translate
      "
      [matTooltip]="'ADMIN_PAGE.USERS.TABLE.HEADER.ACTIONS.ADD' | translate"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
<table mat-table [dataSource]="dataSource() ?? []" class="mat-elevation-z8">
  <caption class="cdk-visually-hidden">
    {{ 'ADMIN_PAGE.USERS.TABLE.CAPTION' | translate }}
  </caption>
  <ng-container matColumnDef="badgeNumber">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'ADMIN_PAGE.USERS.TABLE.HEADER.BADGE_NUMBER' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.details.badgeNumber }}
    </td>
  </ng-container>

  <ng-container matColumnDef="lastName">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'ADMIN_PAGE.USERS.TABLE.HEADER.LASTNAME' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.details.lastName }}</td>
  </ng-container>

  <ng-container matColumnDef="firstName">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'ADMIN_PAGE.USERS.TABLE.HEADER.FIRSTNAME' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.details.firstName }}</td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'ADMIN_PAGE.USERS.TABLE.HEADER.EMAIL' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.details.email }}</td>
  </ng-container>

  <ng-container matColumnDef="level">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'ADMIN_PAGE.USERS.TABLE.HEADER.LEVEL' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      @if (element.details.level) {
        {{ element.details.level }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="role">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'ADMIN_PAGE.USERS.TABLE.HEADER.ROLE' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ 'USER.ROLE.' + element.details.role | translate }}
    </td>
  </ng-container>

  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'ADMIN_PAGE.USERS.TABLE.HEADER.TITLE' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      @if (element.details.title) {
        {{ element.details.title }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="enabled">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'ADMIN_PAGE.USERS.TABLE.HEADER.ENABLED' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <ng-container>
        @if (element.details.enabled) {
          <mat-icon class="!text-green-500">check</mat-icon>
          <span class="cdk-visually-hidden">
            {{ 'ADMIN_PAGE.ACCESSIBILITY.ICONS.ENABLED' | translate }}
          </span>
        } @else {
          <mat-icon class="!text-red-500">close</mat-icon>
          <span class="cdk-visually-hidden">
            {{ 'ADMIN_PAGE.ACCESSIBILITY.ICONS.DISABLED' | translate }}
          </span>
        }
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'ADMIN_PAGE.USERS.TABLE.HEADER.ACTIONS.TITLE' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      <button
        mat-icon-button
        color="primary"
        (click)="openModifyDialog(element)"
        [attr.aria-label]="'ADMIN_PAGE.USERS.ACTIONS.MODIFY' | translate"
        [matTooltip]="'ADMIN_PAGE.USERS.ACTIONS.MODIFY' | translate"
      >
        <mat-icon class="!text-green-500">edit</mat-icon>
      </button>
      <button
        mat-icon-button
        color="warn"
        (click)="delete.emit(element)"
        [attr.aria-label]="'ADMIN_PAGE.USERS.ACTIONS.DELETE' | translate"
        [matTooltip]="'ADMIN_PAGE.USERS.ACTIONS.DELETE' | translate"
      >
        <mat-icon class="!text-red-500">delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<mat-paginator
  [pageSizeOptions]="[10, 15, 20]"
  showFirstLastButtons
  [attr.aria-label]="
    'ADMIN_PAGE.CONFIGURATIONS.ARIA_LABEL_PAGINATION' | translate
  "
/>
